export function isShortId(inputString: string) {
  const re = /^[0-9a-f]{8}$/i;
  return re.test(inputString);
}

export function getShortIdFromUrl(urlId: string) {
  return urlId.split('-').pop();
}

export function getShortIdFromUrlWithoutSplit(urlId: string) {
  return urlId.slice(-8);
}
